import type { MonthlyBreakdownReport } from 'model/BookingsMonthlyBreakdownReport';

export enum MonthlyBreakdownReportStatus {
    Initial = 'Initial',
    Getting = 'Getting',
    GettingSuccess = 'GettingSuccess',
    Error = 'Error'
}

const emptyMonthValues = () => ({
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0,
    total: 0
});

const emptyCountPercentRow = () => ({
    values: {
        jan: { value: 0, pct: 0 },
        feb: { value: 0, pct: 0 },
        mar: { value: 0, pct: 0 },
        apr: { value: 0, pct: 0 },
        may: { value: 0, pct: 0 },
        jun: { value: 0, pct: 0 },
        jul: { value: 0, pct: 0 },
        aug: { value: 0, pct: 0 },
        sep: { value: 0, pct: 0 },
        oct: { value: 0, pct: 0 },
        nov: { value: 0, pct: 0 },
        dec: { value: 0, pct: 0 }
    },
    total: 0
});

export const emptyMonthlyBreakdownReport: MonthlyBreakdownReport = {
    year: 0,

    totalBookings: emptyMonthValues(),
    totalClients: emptyMonthValues(),
    totalPets: emptyMonthValues(),

    totalServices: emptyMonthValues(),
    totalAddons: emptyMonthValues(),
    totalProducts: emptyMonthValues(),
    totalCustomItems: emptyMonthValues(),

    completed: emptyCountPercentRow(),
    canceled: emptyCountPercentRow(),
    noShow: emptyCountPercentRow(),

    netSales: emptyMonthValues()
};

export interface MonthlyBreakdownReportState {
    report: MonthlyBreakdownReport;
    status: MonthlyBreakdownReportStatus;
    loading: boolean;
}
